module.exports = __webpack_public_path__ + "static/media/giphy.98f51cd9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/giphy.gif
// module id = 18
// module chunks = 0